import _ from 'lodash';

const warningExceptionCode = 10000;

const parseErrorMessage = message => _.split(message, 'ErrorMessage: ')[2];

/**
 * US26877 handle prequalification error messages
 */
function handleQualificationError(error) {
  const errorMessage = parseErrorMessage(error.baseError);
  const isWarning = error.appErrorCode === warningExceptionCode; 
  const messageType = isWarning ? 'warning' : 'error';
  return {errorMessage, isWarning, messageType}; 
}

/**
 * @namespace QuestionSetsViewModelUtil
 * @memberof module:gw-portals-questionsets-js
 */
export default {
    handleQualificationError
};
